import React from 'react'

// query
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_BY_ID_WITH_SPECIFICATIONS } from '../../../../../graphql/equipment/equipment.queries'

// components
import Card from '../../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../../components/cards/CardDataPoint/CardDataPoint.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons'

const EQUIPMENT_CATEGORY_CHOICES = {
    UU: 'Unknown'
}

export default function EquipmentSpecifications({ id }) {
    let equipment = {}

    const { loading, error, data } = useQuery(GET_EQUIPMENT_BY_ID_WITH_SPECIFICATIONS, {
        variables: { id }
    })

    if(data && data.equipment) {
        equipment = {...data.equipment}
    }

    return (<Card header={{ icon: <FontAwesomeIcon icon={faInfo} size='2x' color='#707070' />, title: "Specifications"}}>
        <CardDataPoint label="Category" value={equipment.category ? equipment.category.name : ""} />
        <CardDataPoint label="SKU" value={equipment.sku} />
        <CardDataPoint label="Weight" value={`${equipment.itemWeightInLbs} lbs`} />
    </Card>)
}